import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/5 bg-charcoal-dark text-center" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <h3 className="text-xl font-serif text-gold mb-4" data-id="element-116">
          Emprendé con Focaccias
        </h3>
        <p className="text-cream-muted/60 text-sm mb-8" data-id="element-117">
          De tu cocina a tus primeras ventas.
        </p>
        <div className="text-xs text-cream-muted/40" data-id="element-118">
          &copy; {new Date().getFullYear()} Emprendé con Focaccias. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}